<template>
  <div class="tHPayWithdrawContainerParentDiv">
    <div
        style="display: flex; flex-direction: row; align-items: center; justify-content: space-between"
    >
      <div style="display: flex; flex-direction: row; align-items: center">
        <div class="shuLine" />
        <div :style="hcf.getTextStyle({ addSize: 1 })">{{ title }}</div>
      </div>

      <div class="parsed-desc">
        <template v-for="(part, index) in parsedDesc" :key="index">
          <span v-if="part.type === 'text'">{{ part.content }}</span>
          <button
              v-else
              class="desc-button"
              :style="{
                backgroundColor:getEachContainerBgColor(false),
                color:'var(--ct-main-color)',
              }"
              @click="openLink(part.url)"
          >
            {{ part.title }}
          </button>
        </template>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup>
  import { computed } from "vue";
  import { hcf } from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const props = defineProps({
    title: String,
    desc: String,
  });

  // 解析带按钮的字符串 desc
  const parsedDesc = computed(() => {
    const input = props.desc || "";
    const regex = /\[(.*?)\]/g;
    let match;
    let lastIndex = 0;
    const result = [];

    while ((match = regex.exec(input)) !== null) {
      if (match.index > lastIndex) {
        result.push({
          type: "text",
          content: input.substring(lastIndex, match.index),
        });
      }

      const inside = match[1];
      const [title, url] = inside.split("|");
      if (title && url) {
        result.push({
          type: "button",
          title: title.trim(),
          url: url.trim(),
        });
      }

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < input.length) {
      result.push({
        type: "text",
        content: input.substring(lastIndex),
      });
    }

    return result;
  });
  function getEachContainerBgColor(isSelect){
    if(HNewGameUIConfig.newGameUIType === 3){
      if(isSelect){
        return "#3F362E";
      }else{
        return "#191B15";
      }
    }else{
      return "#f7f7f7";
    }
  }
  function openLink(url) {
    window.open(url, "_blank");
  }
</script>

<style scoped>
  .shuLine {
    margin-right: 5px;
    width: 3px;
    height: 13px;
    border-radius: 10px;
    background-color: var(--ct-main-color);
  }

  /* 桌面: 上面的 3px/13px 在 CSS 文件里会被 postcss-px-to-viewport 转成 vw, 宽屏下被放大成
     又粗又高的一根竖条。@media 内的 px 不被转换, 这里用真实 px 还原成细短的标题竖线。 */
  @media (min-width: 1024px) {
    .shuLine {
      width: 3px;
      height: 14px;
      /* 基础 margin-right:5px 被转 vw 后放大, 标题离竖线太远; 还原真实小间距。 */
      margin-right: 7px;
    }
  }

  .tHPayWithdrawContainerParentDiv {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: var(--ct-main-container-bg-color);
    margin: 10px;
    border-radius: 10px;
  }

  /* 按钮解析样式 */
  .parsed-desc {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    color: #777;
    font-size: 13px;
  }

  .desc-button {
    border: none;
    border-radius: 6px;
    padding: 2px 5px;
    cursor: pointer;
    font-size: 12px;
    margin-left: 6px;
  }

  /* 桌面: 上面这些 px 会被 postcss-px-to-viewport 转成 vw, 宽屏下被放大(板块间距 ~50px、
     标题右侧描述"禁止24小时延时到账"/按钮字号过大)。@media 内 px 不被转换, 这里统一还原成
     真实 px。⚠ 本块必须放在所有基础规则之后 —— 同特异性下靠源码顺序取胜, 否则会被后面的
     基础规则(转成 vw 的 font-size)覆盖回去。 */
  @media (min-width: 1024px) {
    .tHPayWithdrawContainerParentDiv {
      margin: 10px;
      padding: 12px;
    }

    /* 标题右侧描述文字(如支付渠道的说明); 支付方式未传 desc 故此处为空、无文字。 */
    .parsed-desc {
      font-size: 13px;
    }

    .desc-button {
      font-size: 12px;
      padding: 2px 5px;
      border-radius: 6px;
    }
  }
</style>
